module.exports = __webpack_public_path__ + "img/zhushuju.ffcf9acc.png";